import type { IconSvgObject } from './types';

const Progress01Icon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }]
];

export default Progress01Icon;
